import { MAIL_FOLDERS, MAIL_TABS } from "../../../../constants.js";
import { useMailStore } from "../../../../stores/MailStore.js";
import "react";
import { BottomMenu, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Mail/screens/MailSidebarScreen/components/MailSectionsBottomMenu/index.tsx
var MailSectionsBottomMenu = () => {
	const activeTab = useMailStore((state) => state.activeTab);
	const setActiveTab = useMailStore((state) => state.setActiveTab);
	const setFolder = useMailStore((state) => state.setFolder);
	const setView = useMailStore((state) => state.setView);
	return /* @__PURE__ */ jsx(BottomMenu, { children: MAIL_TABS.map(({ icon, id, name }) => /* @__PURE__ */ jsx(BottomMenu.Item, {
		className: "flex flex-row flex-wrap",
		onClick: () => {
			setView(id);
			setActiveTab(id);
			if (Object.values(MAIL_FOLDERS).includes(id)) setFolder(id);
		},
		isActive: activeTab === id,
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex items-center",
			children: [/* @__PURE__ */ jsx(Icon, {
				Icon: icon,
				size: "sm",
				className: "mr-xxs"
			}), /* @__PURE__ */ jsx("span", {
				className: "text-sm capitalize",
				children: name
			})]
		})
	}, id)) });
};
//#endregion
export { MailSectionsBottomMenu };

//# sourceMappingURL=index.js.map